import { gql } from '@apollo/client'
import PropTypes from 'prop-types'

const eventVideoFragment = gql`
  fragment eventVideo on EventVideo {
    id
    platform
    videoPlatformId
    videoUrl
    title
    thumbnailUrl
  }
`

export const eventVideoPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  platform: PropTypes.oneOf(['YOUTUBE']).isRequired,
  videoPlatformId: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
})

export default eventVideoFragment
